export const FETCH_ESERVICES_LIST_SUCCESS = 'FETCH_ESERVICES_LIST_SUCCESS';
export const ESERVICES_SET_PARCELS_SUCCESS = 'ESERVICES_SET_PARCELS_SUCCESS';
export const GET_ASW_USER_INFO_SUCCESS = 'GET_ASW_USER_INFO_SUCCESS';
